import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid, watch_id, size = 999) {
		return context.$http.get(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/?size=' + size,
			headers.bearer()
		)
	},
	getAllByDates (context, user_uid, watch_id, date_start, date_end) {
		return context.$http.get(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/between-dates/?start=' + date_start + '&end=' + date_end,
			headers.bearer()
		)
	},
	getAllForToday (context, user_uid, watch_id, date) {
		return context.$http.get(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/between-dates/?start=' + date,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id, id) {
		return context.$http.get(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/' + id,
			headers.bearer()
		)
	},
	add (context, user_uid, watch_id, model) {
		return context.$http.post(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes',
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, model) {
		return context.$http.put(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/' + model.id,
			model,
			headers.bearer()
		)
	},
	delete (context, user_uid, watch_id, id) {
		return context.$http.delete(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/' + id,
			headers.bearer()
		)
	},
	// Pills
	getPills (context, user_uid, watch_id, pillbox_id) {
		return context.$http.get(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/' + pillbox_id + '/pills/',
			headers.bearer()
		)
	},
	getPill (context, user_uid, watch_id, pillbox_id, id) {
		return context.$http.get(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/' + pillbox_id + '/pills/' + id,
			headers.bearer()
		)
	},
	addPill (context, user_uid, watch_id, pillbox_id, model) {
		return context.$http.post(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/' + pillbox_id + '/pills',
			model,
			headers.bearer()
		)
	},
	editPill (context, user_uid, watch_id, pillbox_id, model) {
		return context.$http.put(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/' + pillbox_id + '/pills/' + model.id,
			model,
			headers.bearer()
		)
	},
	deletePill (context, user_uid, watch_id, pillbox_id, pill_id) {
		return context.$http.delete(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/' + pillbox_id + '/pills/' + pill_id,
			headers.bearer()
		)
	},
	// Pills taken
	getPillsByDateAndTime (context, user_uid, watch_id, date, time) {
		return context.$http.get(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillboxes/between-dates/?start=' + date + '&time_of_day=' + time,
			headers.bearer()
		)
	},
	getAllPillstaken (context, user_uid, watch_id) {
		return context.$http.get(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillstaken/',
			headers.bearer()
		)
	},
	addPillstaken (context, user_uid, watch_id, model) {
		return context.$http.post(
			url + '/users/' + user_uid + '/watches/' + watch_id + '/pillstaken',
			model,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/pillboxes.js